<template lang="pug">
  div
    .loading(v-if="isActive")
      .header-logo
      .loading-drum
        img(class="loading-img" src="/img/drum.svg")

    .wf-container(:class="{'is-fadeIn': !isActive}")
      .wf-box(
        v-for="(product, key) in products"
        @mouseover="toggleHover(key)"
        @mouseleave="currentIndex = -1"
        :class="{'is-active': currentIndex === key}")
        img(:src="product.cover" class="cover_img")
        .wf-caption(@click="changeURL(product.name)")
          template(v-if="product.name !== 'KettleBell-Advanced'")
            .wf-captionBox
              .wf-caption-title {{ product.name }}
          template(v-else)
            .wf-captionBox
              .wf-caption-title(v-for="name in splitName(product.name)") {{ name }}


</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line
import Waterfall from "@/utils/responsive_waterfall.js";
import productsConfig from "@/config/product";
// import forEach from "lodash/forEach";
// import keys from "lodash/keys";

export default {
  data() {
    return {
      isActive: true,
      currentIndex: -1,
      products: null
    };
  },

  created() {
    this.products = productsConfig.sort((a, b) => {
      return a.id - b.id;
    });
  },

  mounted() {
    let newP = new Promise((res, rej) => {
      if (this.isActive) {
        res();
      } else {
        rej();
      }
    });

    newP
      .then(() => {
        this.init();
        setTimeout(() => {
          this.isActive = false;
        }, 2500);
      })
      .catch(err => {
        new Error(err);
      });
  },
  methods: {
    init() {
      new Waterfall({
        containerSelector: ".wf-container",
        boxSelector: ".wf-box",
        minBoxWidth: 400
      });

      // var boxHandle = this.newNode();
      // var checkSlide = this.checkSlide;

      // window.onscroll = function() {
      //   var i = waterfall.getHighestIndex();
      //   if (i > -1) {
      //     // get last box of the column
      //     var lastBox = Array.prototype.slice.call(
      //       waterfall.columns[i].children,
      //       -1
      //     )[0];
      //     if (checkSlide(lastBox)) {
      //       var count = 5;
      //       while (count--) waterfall.addBox(boxHandle());
      //     }
      //   }
      // };
    },

    splitName(name) {
      const finalName = name.split("-");
      return finalName;
    },

    checkSlide(elem) {
      if (elem) {
        var screenHeight =
          (document.documentElement.scrollTop || document.body.scrollTop) +
          (document.documentElement.clientHeight || document.body.clientHeight);

        var elemHeight = elem.offsetTop + elem.offsetHeight / 2;

        return elemHeight < screenHeight;
      }
    },
    // newNode() {
    //   let leng = keys(this.products).length;
    //   let imgs = [];
    //   forEach(this.products.cover, cover => {
    //     imgs.push(cover);
    //   });
    //   var i = keys(this.products.imgs).length;

    //   return function() {
    //     var box = document.createElement("div");
    //     box.className = "wf-box";
    //     var image = document.createElement("img");
    //     image.src = imgs[i];
    //     console.log('image.src', image.src, i)
    //     box.appendChild(image);

    //     if (i++ < leng) {
    //       return box;
    //     } else {
    //       return null;
    //     }
    //   };
    // },
    toggleHover(index) {
      this.currentIndex = index;
    },
    changeURL(key) {
      // this.$router.push(`/${key}`);
      this.$router.push({ name: "product", params: { PName: key } });
    }
  }
};
</script>

<style lang="sass">
@keyframes left-drum
  0%
    transform: rotate(-85deg)
  100%
    transform: rotate(-69deg)

@keyframes right-drum
  0%
    transform: rotate(71deg)
  100%
    transform: rotate(84deg)

@keyframes drum
  0%
    transform: rotate(1deg)
  50%
    transform: rotate(0deg)
  100%
    transform: rotate(-1deg)

.loading
  .header-logo
    position: fixed
    right: 0
    left: 0
    top: 10px
    padding: 0
    margin: 0 auto
    height: 100px
    background-image: url('/img/logo.png')

.loading-img
  width: 100%
  height: auto
  max-width: 100%
  transform: rotate(1deg)
  transform-origin: center
  animation: drum .08s infinite alternate

.loading-drum
  position: relative
  width: 95px
  &::before,
  &::after
    content: ''
    width: 4px
    height: 67px
    border-radius: 2px
    background-color: black
    position: absolute
    top: -30px
  &::before
    transform: rotate(-69deg)
    transform-origin: 0 30%
    left: -6px
    top: -22px
    animation: left-drum .12s infinite
  &::after
    transform: rotate(71deg)
    transform-origin: 0 30%
    right: -7px
    top: -23px
    animation: right-drum .12s infinite
</style>
